export const faqs = [
  {
    q: 'Ce système convient-il aux débutants ?',
    a: [
      "Oui. Le système est organisé progressivement, en commençant par les fondations avant d'aborder les différentes phases de préparation jusqu'à l'exécution de la course.",
      "Vous n'avez pas besoin d'être un triathlète expérimenté pour comprendre le cadre proposé.",
      'Votre entraînement doit néanmoins être adapté à votre niveau, à votre expérience et à vos contraintes personnelles.',
    ],
  },
  {
    q: "Ai-je besoin d'un entraîneur pour utiliser ce système ?",
    a: [
      'Le système est conçu comme une ressource éducative pratique que vous pouvez consulter de manière autonome.',
      "Il ne remplace pas un accompagnement individuel. Vous pouvez également l'utiliser en complément des conseils d'un entraîneur qualifié.",
    ],
  },
  {
    q: "Ai-je besoin d'aller en salle de sport ?",
    a: [
      "Le système porte sur l'organisation de votre préparation au triathlon. Les besoins en matériel et en installations dépendent des séances choisies et de votre situation personnelle.",
    ],
  },
  {
    q: "S'agit-il d'un livre physique ?",
    a: [
      'Non. LE SYSTÈME TRIATHLON LONGUE DISTANCE™ est un produit numérique fourni au format PDF. Aucun livre physique ne sera expédié.',
    ],
  },
  {
    q: "S'agit-il d'un paiement unique ?",
    a: [
      "Oui. L'offre présentée correspond à un paiement unique, avec accès à vie aux ressources numériques achetées, conformément aux conditions applicables.",
    ],
  },
  {
    q: 'Comment accéder au contenu ?',
    a: [
      "Après votre achat, suivez les instructions d'accès numérique fournies avec votre commande. Vous pourrez consulter les documents sur vos appareils compatibles.",
    ],
  },
  {
    q: 'Les quatre bonus sont-ils inclus ?',
    a: [
      "Oui. L'offre comprend les quatre outils pratiques présentés sur cette page, en complément du système principal en six volumes.",
    ],
  },
  {
    q: 'Puis-je utiliser le système sur Android et iOS ?',
    a: [
      "Oui. Les documents PDF peuvent être consultés sur les appareils Android et iOS compatibles à l'aide d'un lecteur PDF adapté.",
    ],
  },
  {
    q: "S'agit-il d'un service de coaching personnalisé ?",
    a: [
      "Non. Il s'agit d'un système éducatif numérique accompagné d'outils pratiques de planification. Il ne fournit pas de coaching individualisé, de diagnostic médical ni de prescription nutritionnelle personnalisée.",
    ],
  },
  {
    q: 'Le système garantit-il que je terminerai mon triathlon ?',
    a: [
      'Aucune ressource d\'entraînement ne peut garantir un résultat sportif particulier. Votre performance dépend de nombreux facteurs, notamment votre préparation, votre expérience, votre état de santé, votre récupération et les conditions de course.',
      "Le système a pour objectif de vous aider à organiser votre préparation, et non de garantir un résultat spécifique.",
    ],
  },
];

export const steps = [
  {
    n: '1',
    title: 'Téléchargement immédiat',
    body: "Achetez LE SYSTÈME TRIATHLON LONGUE DISTANCE™ et accédez au système complet en six volumes ainsi qu'aux quatre bonus pratiques. Pas de livraison physique. Pas d'attente. Commencez lorsque vous êtes prêt.",
    tags: [] as string[],
    after: '',
  },
  {
    n: '2',
    title: 'Organisez votre préparation',
    body: 'Parcourez les six volumes et organisez votre préparation autour des éléments essentiels :',
    tags: ['Natation', 'Vélo', 'Course à pied', 'Renforcement', 'Récupération', 'Ravitaillement', 'Suivi de progression'],
    after: 'Au lieu de vous demander constamment « Que dois-je faire ensuite ? », vous disposez d’un cadre structuré pour organiser votre préparation.',
  },
  {
    n: '3',
    title: 'Préparez votre course',
    body: 'À mesure que le jour de la compétition approche, utilisez les outils inclus pour organiser :',
    tags: ['Votre entraînement', 'Votre ravitaillement', 'Votre suivi de progression', 'Votre équipement', 'Votre semaine de course', "Votre stratégie d'exécution"],
    after: '',
  },
];
